/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateIamUserResponse
 */
export interface CreateIamUserResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateIamUserResponse
     */
    iamUserId?: string;
}

export function CreateIamUserResponseFromJSON(json: any): CreateIamUserResponse {
    return CreateIamUserResponseFromJSONTyped(json, false);
}

export function CreateIamUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateIamUserResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iamUserId': !exists(json, 'iam_user_id') ? undefined : json['iam_user_id'],
    };
}

export function CreateIamUserResponseToJSON(value?: CreateIamUserResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iam_user_id': value.iamUserId,
    };
}


